'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index$1 = require('../../../node_modules/classnames/index.js');

var index = require('../../../node_modules/prop-types/index.js');

require('../../../primitives/Button/Button.js');

require('../../../primitives/Hero/Hero.js');

var Icon = require('../../../primitives/Icon/Icon.js');

require('../../../primitives/Link/Link.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var NavMobileDropdown = function NavMobileDropdown(props) {
  var className = props.className,
      children = props.children,
      name = props.name,
      link = props.link,
      menuItems = props.menuItems,
      secondary = props.secondary;
  var hasChildren = menuItems.length !== 0;

  var _useState = React.useState(false),
      _useState2 = slicedToArray['default'](_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var navmobiledropdownClasses = index$1['default']('navmobiledropdown', className, 'lanl-navmobiledropdown', secondary ? 'lanl-navmobiledropdown--secondary' : '');
  var dropdownClasses = index$1['default']('dropdown-container', isOpen ? 'dropdown-container--open' : '');

  var renderChevron = function renderChevron() {
    if (hasChildren) {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: isOpen ? 'chevron--open' : ''
      }, /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
        icon: "chevron-down",
        size: "lg",
        onClick: function onClick(e) {
          setIsOpen(!isOpen);
          e.preventDefault();
        }
      }));
    } else {
      return null;
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("li", {
    "data-testid": "lanl-navmobiledropdown",
    className: navmobiledropdownClasses
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: "nav-link-item",
    href: link ? link : '',
    onClick: function onClick(e) {
      if (!link) {
        e.preventDefault();
      }
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "w-100 d-flex justify-content-between align-items-center"
  }, name, renderChevron())), /*#__PURE__*/React__default['default'].createElement("div", {
    className: dropdownClasses
  }, children));
};

NavMobileDropdown.defaultProps = {};
NavMobileDropdown.propTypes = {
  children: index['default'].node,
  className: index['default'].string,
  link: index['default'].string,
  menuItems: index['default'].array,
  name: index['default'].string,
  secondary: index['default'].bool
};
exports.NavMobileDropdown = NavMobileDropdown;
exports['default'] = NavMobileDropdown;